import {

    GET_ADMIN_MENU_FORM_REQUEST, GET_ADMIN_MENU_FORM_SUCCESS, GET_ADMIN_MENU_FORM_ERROR, ADD_ADMIN_MENU_REQUEST, ADD_ADMIN_MENU_SUCCESS, ADD_ADMIN_MENU_ERROR
} from "./types";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getAdminMenuForm = (token) => (dispatch) => {
    dispatch({ type: GET_ADMIN_MENU_FORM_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminMenuForm`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },

    })
        .then((response) => {
            return dispatch({ type: GET_ADMIN_MENU_FORM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ADMIN_MENU_FORM_ERROR,
                payload: error.response,
            });
        });
};


